import { render, staticRenderFns } from "./NewRequestedDocumentRegisterView.vue?vue&type=template&id=37562676&"
import script from "./NewRequestedDocumentRegisterView.vue?vue&type=script&lang=ts&"
export * from "./NewRequestedDocumentRegisterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports